import { createSlice } from '@reduxjs/toolkit';
import { fetchAlerts } from '../thunks/alerts';

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        alert: [],
    },
    reducers: {
        // setAlertData: (state, action) => {
        //     state.alert = action.payload;
        // },
        setAlertData: (state, action) => {
            const incoming = action.payload;
            const existingIds = new Set(state.alert.map(a => a.id));
            state.alert = [...state.alert, ...incoming.filter(a => !existingIds.has(a.id))];
        },

        deleteAlertData: (state, action) => {
            state.alert = state.alert.filter(alert => alert.id !== action.payload);
        },

        saveAlertData: (state, action) => {
            if (!Array.isArray(state.alert)) {
                state.alert = [];
            }
            state.alert.push(action.payload);
        },

        updateAlertData: (state, action) => {
            state.alert = state.alert.map(alert =>
                alert.id === action.payload.id ? action.payload : alert
            );
        },
    }, extraReducers: (builders) => {
        builders.addCase(fetchAlerts.fulfilled, (state, action) => {
            state.alert = Array.isArray(action.payload) ? action.payload : [];
        })
    }
});

export const { setAlertData, deleteAlertData, saveAlertData, updateAlertData } = alertSlice.actions;
export default alertSlice.reducer;
